import { Typography } from '@mui/material';
import { PasswordsMatchTextContainer } from 'components/password-strength/styles';
import { useTranslation } from 'react-i18next';
import theme from 'theme';
import { PROFILE__PINCODE_INVALID, PROFILE__PINCODE_VALID } from 'translations/constants';
import { ReactComponent as CheckIcon } from '../../assets/icons/CheckIcon.svg';

interface PincodeValidTextProps {
  valid: boolean;
}

/** Same visual language as PasswordsMatchText, for the pincode strength/format check. */
const PincodeValidText = ({ valid }: PincodeValidTextProps) => {
  const [t] = useTranslation();

  return (
    <PasswordsMatchTextContainer>
      {valid && <CheckIcon />}
      <Typography fontSize={12} color={valid ? theme.palette.primary.main : theme.palette.error.main}>
        {valid ? t(PROFILE__PINCODE_VALID) : t(PROFILE__PINCODE_INVALID)}
      </Typography>
    </PasswordsMatchTextContainer>
  );
};

export default PincodeValidText;
